export * from "./IEntity";
export * from "./IEntityGettable";
export * from "./IEntitiesGettable";
export * from "./IAllEntitiesGettable";
export * from "./Entity";
export * from "./INameSpecifiable";
export * from "./NameSpecifiedEntity";
export * from "./IValueSpecifiable";
export * from "./INamedValue";
export * from "./IVersionSpecifiable";
export * from "./IEditionSpecifiable";
export * from "./ICreatedSpecifiable";
export * from "./IUpdatedSpecifiable";
